import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { Bookmark } from "lucide-react";

// Category Modal Component
const CategoryModal = ({ open, onClose, categories }) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          padding: '16px'
        }
      }}
    >
      <DialogTitle sx={{ 
        fontSize: '1.5rem', 
        fontWeight: 600,
        color: '#1F2937',
        pb: 1
      }}>
        Deal Categories
      </DialogTitle>
      <DialogContent>
        <div className="grid grid-cols-2 gap-4 py-4">
          {categories.map((category, index) => (
            <div 
              key={index}
              className="flex gap-3 items-center p-4 bg-gray-50 rounded-xl transition-colors hover:bg-gray-100"
            >
              <Bookmark className="w-5 h-5 text-amber-600" />
              <span className="font-medium text-gray-900">{category}</span>
            </div>
          ))}
        </div>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onClose}
          sx={{
            color: '#4B5563',
            '&:hover': { backgroundColor: '#F3F4F6' },
            textTransform: 'none',
            fontWeight: 500
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default CategoryModal;